import Network from '../PREPAREsrc/service/Network';
import { updateAllWorkSpaceList } from 'PREPAREsrc/store/workspaces/workspaces.action';
import API from '../PREPAREsrc/service/api';

export const fetchExerciseWorkspaces = (userId, orgId) => {
  return async (dispatch) => {
    try {
      const { data: workspaces } = await Network.get(
        API.getAllWorkspacesByOrgAndUser,
        {
          userId,
          orgId: orgId,
        }
      );
      dispatch(updateAllWorkSpaceList(workspaces));
    } catch (error) {
      console.error('error fetching exercise workspaces');
      throw error;
    }
  };
};
